module.exports = __webpack_public_path__ + "img/free-trial-img.9b77096e.png";